import { getBackgroundImageOptions } from "@circle-react-shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";

export interface DefaultBlockStyles {
  backgroundColor: string;
  backgroundImage?: {
    signed_id?: string;
    placeholder?: string;
  };
  borderColor?: string;
  margin: {
    marginTop: string;
    marginBottom: string;
    marginLeft: string;
    marginRight: string;
  };
  padding: {
    paddingTop: string;
    paddingBottom: string;
    paddingLeft: string;
    paddingRight: string;
  };
}

export const primaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor: "var(--theme-website-color-background-primary)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const secondaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor: "var(--theme-website-color-background-secondary)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const getHomepageBlockPrimaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: primaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: primaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: primaryBlockDefaultStyles.margin,
  }),
});

export const getHomepageBlockSecondaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: secondaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: secondaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: secondaryBlockDefaultStyles.margin,
  }),
});
